import { CatalogTable } from '@backstage/plugin-catalog';
import {
  CatalogFilterLayout,
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityListProvider,
  EntityOwnerPicker,
  EntityTagPicker,
  EntityTypePicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import {
  ContentHeader,
  SupportButton,
} from '@backstage/core-components';

function ApisOverview() {
  return (
    <>
      <ContentHeader>
        <SupportButton
          items={[
            {
            title: 'INFSUPP',
            icon: 'support',
            links: [
              {
                title: 'Create a ticket for Triton',
                url: 'https://zf-scalar.atlassian.net/secure/CreateIssueDetails!init.jspa?pid=13079&issuetype=10672&summary=APIs%20Overview%20feedback&customfield_12107=11359',
              },
            ],
          },
          {
            title: 'SAM chatbot',
            icon: 'support',
            links: [
              {
                title: 'Ask your questions to our AI bot',
                url: 'https://sam.eu1.scalar.zf.com/',
              },
            ],
          },
        ]}
      >
        All your APIs
      </SupportButton>
    </ContentHeader>

    <EntityListProvider>
      <CatalogFilterLayout>
        <CatalogFilterLayout.Filters>
          <EntityKindPicker initialFilter="api" hidden />
          <EntityTypePicker />
          <UserListPicker />
          <EntityOwnerPicker />
          <EntityLifecyclePicker />
          <EntityTagPicker />
        </CatalogFilterLayout.Filters>

        <CatalogFilterLayout.Content>
          <CatalogTable
            tableOptions={{
              search: true,
              pageSize: 20,
              paginationType: 'normal',
              pageSizeOptions: [20, 50, 100],
              padding: 'dense',
              headerStyle: { position: 'sticky' },
            }}
          />
        </CatalogFilterLayout.Content>
      </CatalogFilterLayout>
    </EntityListProvider>
  </>
);
}

export { ApisOverview };